// @flow

import React, { Component, Fragment } from 'react';
import type { ContactType } from '../../api/types';
import Validator from '../../utils/validation';
import type { ValidationErrorType } from '../../utils/validation';
import Api from '../../api';
import styles from './styles.scss';
import FormField from '../FormField';
import ValidatedField from '../ValidatedField';

type Props = {
  placeId: ?number,
  onSubmit: () => void,
};

type State = {
  data: ContactType,
  errors: Array<ValidationErrorType>,
};

class Form extends Component<Props, State> {
  initialState = {
    data: {
      name: '',
      email: '',
      phone: '',
      text: '',
      artistName: '',
      dates: '',
    },
    errors: [],
  };

  state = this.initialState;

  validator = new Validator({
    name: [Validator.isRequired],
    email: [Validator.isRequired, Validator.isValidEmail],
  });

  handleInputChange = (e: SyntheticInputEvent<HTMLInputElement>) =>
    this.setState({ data: { ...this.state.data, [e.target.name]: e.target.value } });

  handleSubmit = () =>
    this.setState({ errors: this.initialState.errors }, () => {
      const { name, email } = this.state.data;

      const errors = this.validator.validate({ name, email });

      if (errors.length) {
        return this.setState({ errors });
      }

      const contactData = Object.assign({}, { ...this.state.data, place: this.props.placeId });

      for (var key in contactData) {
        if (!contactData[key]) {
          delete contactData[key];
        }
      }

      Api.contact
        .sendContactForm(contactData)
        .then(this.props.onSubmit)
        .catch(error => console.log(error));
    });

  render() {
    const {
      data: { name, phone, email, text, artistName, dates },
      errors,
    } = this.state;

    return (
      <Fragment>
        <div className={styles['form-wrap']}>
          <div className={styles['form-item']}>
            <FormField>
              <FormField.Content>
                <ValidatedField field="name" errors={errors}>
                  <input
                    type="text"
                    name="name"
                    value={name}
                    placeholder="Your name*"
                    onChange={this.handleInputChange}
                  />
                </ValidatedField>
              </FormField.Content>
            </FormField>

            <FormField>
              <FormField.Content>
                <ValidatedField field="phone" errors={errors}>
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone number"
                    value={phone}
                    onChange={this.handleInputChange}
                  />
                </ValidatedField>
              </FormField.Content>
            </FormField>

            <FormField>
              <FormField.Content>
                <ValidatedField field="email" errors={errors}>
                  <input
                    type="text"
                    name="email"
                    placeholder="E-mail*"
                    value={email}
                    onChange={this.handleInputChange}
                  />
                </ValidatedField>
              </FormField.Content>
            </FormField>

            <FormField>
              <FormField.Content>
                <ValidatedField field="artistName" errors={errors}>
                  <input
                    type="text"
                    name="artistName"
                    placeholder="Artist's name"
                    value={artistName}
                    onChange={this.handleInputChange}
                  />
                </ValidatedField>
              </FormField.Content>
            </FormField>

            <FormField>
              <FormField.Content>
                <ValidatedField field="dates" errors={errors}>
                  <input type="text" name="dates" placeholder="Dates" value={dates} onChange={this.handleInputChange} />
                </ValidatedField>
              </FormField.Content>
            </FormField>
          </div>

          <div className={styles['form-item']}>
            <FormField>
              <FormField.Content>
                <textarea name="text" value={text} placeholder="Your message" onChange={this.handleInputChange} />
              </FormField.Content>
            </FormField>
          </div>
        </div>
        <div className={styles['form-footer']}>
          <div className={styles['footer-item']}>
            <span className={styles.notice}>* Required field</span>
          </div>
          <div className={styles['footer-item']}>
            <div onClick={this.handleSubmit} className="btn">
              <span>Send message</span>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Contact/Form.js